import axios from "axios";

// Em desenvolvimento local, REACT_APP_API_BASE_URL pode ser definida como
// string vazia para que as chamadas saiam relativas (ex: "/authenticate")
// e sejam roteadas pelo proxy do servidor de dev do CRA (ver "proxy" no
// package.json), evitando bloqueio de CORS ao testar contra a API real.
// Em produção essa variável não é definida, então cai no REACT_APP_API_URL
// normal (comportamento inalterado).
const baseURL =
  process.env.REACT_APP_API_BASE_URL !== undefined
    ? process.env.REACT_APP_API_BASE_URL
    : process.env.REACT_APP_API_URL;

const api = axios.create({ baseURL });

// api.defaults.withCredentials = true

api.interceptors.request.use((request) => {
  // console.log({request});
  return request;
});

api.interceptors.response.use(
  (response) => {
    // console.log({response});
    return response;
  },
  (error) => {
    console.log({error});
    return Promise.reject(error);
  },
);

export default api;
